import moment from "moment-shortformat";

const formatShortDate = (date: Date): string => moment(date).short(true);
export default formatShortDate;
